import { render, staticRenderFns } from "./addFromAdmin.vue?vue&type=template&id=99c9ea24"
import script from "./addFromAdmin.vue?vue&type=script&lang=js"
export * from "./addFromAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports